import React from 'react';
import { QueryClientProvider } from 'react-query';

import { queryClient } from '@/utils';
import { SUPPORTED_LOCALE_TYPE } from '@/locales';

import { Answer, AnswerProps } from './Answer';
import { Question, QuestionProps } from './Question';

type QaProps = {
  onConfirm: (data: EditorSubmitContentData) => Promise<void>;
  disabled?: boolean;
  className?: string;
  showAnswer?: boolean;
  language?: SUPPORTED_LOCALE_TYPE;
  isDebug?: boolean;
} & Pick<AnswerProps, 'onAnswerConfirm'> &
  Pick<
    QuestionProps,
    'extraPaymentParams' | 'targetAnswerer' | 'priceLimit' | 'minOfferPriceRatio'
  >;

export const Qa = ({
  showAnswer,
  onAnswerConfirm,
  extraPaymentParams,
  targetAnswerer,
  priceLimit,
  ...rest
}: QaProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      {showAnswer ? (
        <Answer onAnswerConfirm={onAnswerConfirm} {...rest} />
      ) : (
        <Question
          extraPaymentParams={extraPaymentParams}
          targetAnswerer={targetAnswerer}
          priceLimit={priceLimit}
          {...rest}
        />
      )}
    </QueryClientProvider>
  );
};
